import moment from 'moment'

export const UTILS_HELPER = {
    deepClone,
    formatDate,
    getISODate,
    shuffle,
    s2ab
};

function deepClone(destination, source)
{
    return Object.assign(destination, JSON.parse(JSON.stringify(source)));
}

function formatDate(date)
{
    if(!(date instanceof Date))
    {
        date = new Date(date);
    }

    return moment(date).format('DD/MM/YYYY');
}

function getISODate(date)
{
    if(!(date instanceof Date))
    {
        date = new Date(date);
    }

    return moment(date).format('YYYY-MM-DD');
}

function shuffle(s) {
    var arr = s.split('');   
    
    arr.sort(function() {
      return 0.5 - Math.random();
    });  
    s = arr.join('');    
    return s; 
}

/* The s2ab (string to array buffer) method (https://github.com/SheetJS/js-xlsx/blob/master/README.md) */
function s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  }